import React from 'react';
import { func } from 'prop-types';
import './overlay-header.style.scss';

const OverlayHeader = ({ onClick }) => {
  return (
    <div className="close-button-wrapper">
      <button className="close-button" onClick={onClick} type="button">
        Close
        <img
          className="close-button__icon"
          height="16px"
          width="16px"
          src="https://assets.homedepot-static.com/images/v1/close-symbol-orange.svg"
          alt="Close"
        />
      </button>
    </div>
  );
};

OverlayHeader.propTypes = {
  onClick: func
};

OverlayHeader.defaultProps = {
  onClick: null
};

export default OverlayHeader;
